import { connect } from 'redux-bundler-react';
import Icon from '@components/icon/Icon';
import { mdiDownload } from '@mdi/js';

import { FileSection, FileSubFolder, FileTypes } from '@src/utils/enums';

import '../../dashboard.scss';
import '@forms/components/gridCellRenderers/cellRenderers.scss';

const handlePDFDownloadHelper = ({ doDownloadFile, projectId, requestId, version, fileData }) => {
  const params = {
    projectID: projectId,
    requestID: requestId,
    version: version ?? 0,
  };
  const fileName = fileData?.fileName;
  let subFolder = '';
  if (fileData?.section === FileSection.AdditionalInformationRequest) {
    subFolder = `${FileSubFolder.AdditionalInformationResponses}/${fileData.ormAdditionalInfoActionID}`;
  } else if (fileData?.DocumentType === FileSection.Generated) {
    subFolder = FileSubFolder.Generated;
  }
  doDownloadFile(fileName, FileTypes.Request, params, subFolder);
};

const FileRowActions = connect('doDownloadFile', ({ doDownloadFile, projectId, requestId, version, fileData }) => {
  const handlePDFDownload = () => handlePDFDownloadHelper({ doDownloadFile, projectId, requestId, version, fileData });

  const handleKeyUp = ({ key }) => {
    if (key === 'Enter') {
      handlePDFDownload();
    }
  };

  return (
    <div className='renderer-div'>
      <div role='button' title='Download File' onClick={handlePDFDownload} onKeyUp={handleKeyUp} tabIndex={0}>
        <Icon className='cell-btn-icon info' focusable={false} path={mdiDownload} size='25px' />
      </div>
    </div>
  );
});

export default FileRowActions;
